import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import html2canvas from 'html2canvas';
import { GoogleDrivePickerService } from '../../../../sunleon/data-access/http/google-drive-picker.service'
import { PickerAction } from 'src/app/sungeo/model/google-drive.enum';
import { environment } from 'src/environments/environment';
import { ModalGenerationLivrableSharepointComponent } from '../../modal-generation-livrable-sharepoint/modal-generation-livrable-sharepoint.component';

@Component({
  selector: 'app-modal-generation-livrable',
  templateUrl: './modal-generation-livrable.component.html',
  styleUrls: ['./modal-generation-livrable.component.scss']
})
export class ModalGenerationLivrableComponent implements OnInit {

  @ViewChild('screenshotContainer', { static: false }) screenshotContainer!: ElementRef<HTMLDivElement>;

  @Input()
  formGroup: FormGroup = this.formBuilder.group({})

  @Input() nomClient!: string;
  @Input() nomProjet!: string;
  @Input() isParentForm!: boolean;

  canvasRef: HTMLCanvasElement | null = null;
  screenshot : HTMLImageElement | null = null;

  submitted = false;

  folderId: string;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    public modalService: NgbModal,
    private googleDrivePickerService: GoogleDrivePickerService,
  ) {
    this.formGroup = this.formBuilder.group({
      nomClient: this.formBuilder.control({ value: 'Marquere Cie', disabled: true }),
      nomProjet: this.formBuilder.control({ value: '345 - Marquere à Chaponost', disabled: true }),
      screenshot : this.formBuilder.control({ value: null}),
      urlFolder: this.formBuilder.control('', [Validators.required]),
      idFolder: this.formBuilder.control('', [Validators.required]),
      csvProjet: this.formBuilder.control({ value: true, disabled: true }),
     csvSlide: this.formBuilder.control(true),
      csvDevis: this.formBuilder.control(true),
      csvVE: this.formBuilder.control(true),
      driveId: ['', [Validators.required]], 
    });
  }

  ngOnInit(): void {
    this.formGroup.controls['nomClient'].setValue(this.nomClient);
    this.formGroup.controls['nomProjet'].setValue(this.nomProjet);
    this.formGroup.controls['urlFolder'].setValue('');
    this.formGroup.controls['idFolder'].setValue('');
    this.formGroup.controls['screenshot'].setValue(null);

    if(environment.name == 'local') {
      this.formGroup.controls['idFolder'].clearValidators();
      this.formGroup.controls['idFolder'].updateValueAndValidity();

      this.formGroup.controls['urlFolder'].clearValidators();
      this.formGroup.controls['urlFolder'].updateValueAndValidity();
    }
  }

  takeScreenshot() {
    const element = document.getElementById('mapContainer');
    if (!element) {
      console.error('map introuvable');
      return;
    }

    html2canvas(element, {
      useCORS: true,
      allowTaint: false
    }).then(canvas => {

      this.canvasRef = canvas;

      const container = this.screenshotContainer.nativeElement;
      container.innerHTML = '';

      this.screenshot = new Image();
      this.screenshot.src = canvas.toDataURL('image/png');
      this.screenshot.style.maxWidth = '100%';
      this.screenshot.style.height = 'auto';

      this.formGroup.controls['screenshot'].setValue(this.dataURLtoFile(this.screenshot.src, "capture.png"));  

      container.appendChild(this.screenshot);
    });
  }

  dataURLtoFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  openGooglePicker() {
    this.googleDrivePickerService.openGooglePicker((data: any) => {
      if (data.action === PickerAction.PICKED) {
        const picked = data.docs[0];

        if (picked.type === 'folder') {
          this.formGroup.controls['urlFolder'].setValue(picked.url);
          this.formGroup.controls['idFolder'].setValue(picked.id);
          this.folderId = picked.id
        } else {
          console.log('Ce n’est pas un dossier.');
        }
      } else if (data.action === PickerAction.CANCEL) {
        console.log('Sélection annulée.');
      }
    });
  }

  openSharepointPicker() {
    const modalRef = this.modalService.open(ModalGenerationLivrableSharepointComponent, {
      size: 'xl',
      centered: true
    });
    modalRef.result.then((selection) => {
      if (selection) {
        this.formGroup.patchValue({
          urlFolder: selection.webUrl,
          idFolder: selection.folderItemId,
          driveId: selection.driveId,
        });
      }
    }).catch(() => {
      // annulé
    });

  }

  onSubmit() {
    this.submitted = true;

    if (this.formGroup.valid) {
      this.activeModal.close(this.formGroup.getRawValue());
    }
  }
}
